import { render } from "./CircleInfo.vue?vue&type=template&id=b0d8b1f4"
import script from "./CircleInfo.vue?vue&type=script&lang=js"
export * from "./CircleInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__